import { Grid, Typography } from "@mui/material";
import theme from "../../../theme";
import { filterConstants } from "../../../constants/AppConstants";

interface propTypes {
  Label: string;
  LabelValue: string;
}
const VoucherLabel = (props: propTypes) => {
  const { Label, LabelValue } = props;

  const getColor = (labelData: string) => {
    switch (labelData) {
      case filterConstants.Pending:
        return "#F1B53D";
      case filterConstants.Accepted:
        return "#76CE16";
      case filterConstants.Rejected:
        return "#F13950";
      default:
        return "#717171";
    }
  };
  return (
    <Grid
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Typography
        sx={{
          fontFamily: theme.font?.fontFamily.primary,
          fontSize: "32px",
          fontWeight: theme.font?.fontWeight.thick,
          color: getColor(""),
        }}
      >
        {LabelValue}
      </Typography>
      <Typography
        sx={{
          fontFamily: theme.font?.fontFamily.primary,
          fontSize: "20px",
          fontWeight: theme.font?.fontWeight.thick,
          color: getColor(Label),
        }}
      >
        {Label}
      </Typography>
    </Grid>
  );
};
export default VoucherLabel;
